<div class="with-floating-button">
    <div class="content">
        <list-view [liste]="listeDelegationRecue" *ngIf="listeDelegationRecue"></list-view>

        <list-view [liste]="listeDelegationAccordee" *ngIf="listeDelegationAccordee"></list-view>
    </div>
    <floating-button [listeActions]="listeActions"></floating-button>
</div>
